import '../../../../neb-material-design/src/components/neb-md-button';
import '../../../../neb-lit-components/src/components/neb-pagination';
import { openPopup } from '@neb/popup';
import { LitElement, html, css } from 'lit';

import { checkInAppointment } from '../../../../../src/api-clients/appointments';
import { getAppointmentQuestionnaireBooking } from '../../../../../src/api-clients/questionnaires';
import { SELF_CHECK_IN_INTERVAL_MESSAGE } from '../../../../../src/components/pages/online-booking/neb-page-landing';
import {
  TYPE,
  canCheckInAppointment,
} from '../../../../../src/components/tables/booking/neb-table-appointments';
import { navigate } from '../../../../../src/store';
import {
  CSS_COLOR_HIGHLIGHT,
  CSS_FONT_SIZE_CAPTION,
  CSS_FONT_SIZE_HEADER,
  CSS_FONT_WEIGHT_BOLD,
  CSS_SPACING,
} from '../../../../../src/styles';
import { getBookingAppointments } from '../../../../neb-api-client/src/appointment-api-client';
import {
  openError,
  openSuccess,
} from '../../../../neb-dialog/neb-banner-state';
import { POPUP_RENDER_KEYS } from '../../../../neb-popup/src/renderer-keys';
import { store, connect } from '../../../../neb-redux/neb-redux-store';
import { baseStyles } from '../../../../neb-styles/neb-styles';
import { FetchService } from '../../../../neb-utils/services/fetch';
import { MODE } from '../../../../neb-utils/table';
import { UNAVAILABLE_LOCATION } from '../appointment/neb-booking-appointment-page';

export const ELEMENTS = {
  createAppointment: { id: 'create-appointment' },
  upcomingAppointmentsTable: { id: 'table-appointments-upcoming' },
  pastAppointmentsTable: { id: 'table-appointments-past' },
  bookAnotherButton: { id: 'button-book-another' },
  futurePagination: { id: 'future-pagination', tag: 'neb-pagination' },
  pastPagination: { id: 'past-pagination', tag: 'neb-pagination' },
  subHeaderSelfCheckIn: { selector: '.sub-header' },
};

const UPCOMING_APPOINTMENTS = 'Upcoming Appointments';
const PAST_APPOINTMENTS = 'Past Appointments';
const TEXT_BOOK_ANOTHER_BUTTON = 'Book Another Appointment';

const LIMIT = 5;

export const CONFIG = [
  {
    key: 'start',
    label: '',
    flex: css`1 0 0`,
    mobile: true,
  },
  {
    key: 'appointmentTypeName',
    label: '',
    flex: css`1 0 0`,
    mobile: true,
  },
  {
    key: 'checkInButton',
    label: '',
    flex: css`0 0 135px`,
  },
  {
    key: 'viewButton',
    label: '',
    flex: css`0 0 0`,
  },
];
class NebMyAppointments extends connect(store)(LitElement) {
  static get properties() {
    return {
      __futureAppointments: Array,
      __futureCurrentPage: Number,
      __futurePageCount: Number,
      __pastAppointments: Array,
      __pastCurrentPage: Number,
      __pastPageCount: Number,
      __hasTenantId: Boolean,
      __hasToken: Boolean,
      __appointmentId: String,

      enableBooking: Boolean,
      enableSelfCheckIn: Boolean,
      selfCheckInInterval: Number,
      locations: Array,
      providers: Array,
      layout: {
        type: String,
        reflect: true,
      },
      user: Object,
    };
  }

  static get styles() {
    return [
      baseStyles,
      css`
        .icon-container {
          display: flex;
          justify-content: space-between;
        }

        :host([layout='small']) .icon-container {
          padding-left: 16px;
        }

        .pagination {
          flex-direction: row-reverse;
          padding-top: ${CSS_SPACING};
          padding-right: 10px;
          margin-bottom: ${CSS_SPACING};
        }

        .sub-header {
          font-size: ${CSS_FONT_SIZE_CAPTION};
          margin-top: 10px;
        }

        :host([layout='small']) .sub-header {
          padding: 0px ${CSS_SPACING};
        }

        .title {
          color: ${CSS_COLOR_HIGHLIGHT};
          font-size: ${CSS_FONT_SIZE_HEADER};
          font-weight: ${CSS_FONT_WEIGHT_BOLD};
          padding-top: 30px;
        }

        :host([layout='small']) .title {
          padding: 30px ${CSS_SPACING} 0px;
        }
      `,
    ];
  }

  constructor() {
    super();

    this.__initState();
    this.__initServices();
    this.__initHandlers();
  }

  __initState() {
    this.__fetchedOnInitialLoad = false;
    this.__futureAppointments = [];
    this.__futureCurrentPage = 0;
    this.__futurePageCount = 0;
    this.__hasTenantId = false;
    this.__hasToken = false;
    this.__pastAppointments = [];
    this.__pastCurrentPage = 0;
    this.__pastPageCount = 0;
    this.__appointmentId = '';

    this.enableBooking = false;
    this.enableSelfCheckIn = true;
    this.selfCheckInInterval = 12;
    this.layout = '';
    this.providers = [];
    this.locations = [];
    this.user = {};
  }

  __getLocationName(locationId) {
    if (!locationId) return null;

    const location = this.locations.find(l => l.id === locationId);

    if (!location) return UNAVAILABLE_LOCATION.name;

    return this.locations.length > 1 ? location.name : null;
  }

  __initServices() {
    this.__futureAppointmentsFetchService = new FetchService(
      {
        onChange: ({ pageItems, pageCount, pageIndex }) => {
          this.__futureAppointments = pageItems.map(appointment => ({
            ...appointment,
            locationName: this.__getLocationName(appointment.locationId),
          }));

          this.__futurePageCount = pageCount;
          this.__futureCurrentPage = pageIndex;
        },
        onMapItem: item => this.__onMapItem(item),
      },
      getBookingAppointments,
      {
        pageSize: LIMIT,
        hideInactive: false,
      },
    );

    this.__pastAppointmentsFetchService = new FetchService(
      {
        onChange: ({ pageItems, pageCount, pageIndex }) => {
          this.__pastAppointments = pageItems.map(appointment => ({
            ...appointment,
            locationName: this.__getLocationName(appointment.locationId),
          }));

          this.__pastPageCount = pageCount;
          this.__pastCurrentPage = pageIndex;
        },
        onMapItem: item => this.__onMapItem(item),
      },
      getBookingAppointments,
      {
        pageSize: LIMIT,
        hideInactive: false,
      },
    );

    this.__futureAppointmentsFetchService.setQuery('type', TYPE.FUTURE);
    this.__pastAppointmentsFetchService.setQuery('type', TYPE.PAST);
  }

  __initHandlers() {
    this.__handlers = {
      navigateToBookAppointment: () => {
        navigate('#/book-appointment');
      },
      openAppointment: (_, item) => {
        navigate(`#/appointment/${item.id}`);
      },
      checkInAppointment: async appointment => {
        this.__appointmentId = appointment.id;

        try {
          await this.__openQuestionnairePopup();
        } catch (e) {
          console.error(e);
          this.__renderErrorBanner();
        }
      },
      futurePageChanged: pageIndex => {
        this.__futureAppointmentsFetchService.setPageIndex(pageIndex);
      },
      pastPageChanged: pageIndex => {
        this.__pastAppointmentsFetchService.setPageIndex(pageIndex);
      },
      save: async (questionnaireNarrative, noChangeInSymptoms) => {
        try {
          await this.__checkInAppointment(
            questionnaireNarrative,
            noChangeInSymptoms,
          );

          return true;
        } catch (e) {
          this.__renderErrorBanner();
          return false;
        }
      },
    };
  }

  _stateChanged(state) {
    if (
      state.onlineBooking &&
      state.onlineBooking.item &&
      state.onlineBooking.item.tenantId
    ) {
      this.__hasTenantId = true;
    }

    if (state.session.item && state.session.item.idToken) {
      this.__hasToken = true;
    }
  }

  updated(changedProps) {
    if (!this.user) {
      navigate('#/');
    }

    if (
      (changedProps.has('__hasTenantId') || changedProps.has('__hasToken')) &&
      this.__hasTenantId &&
      this.__hasToken
    ) {
      this.__futureAppointmentsFetchService.fetch();
      this.__pastAppointmentsFetchService.fetch();
    }
  }

  async __openQuestionnairePopup() {
    const id = this.__appointmentId;

    const questionnaire = await getAppointmentQuestionnaireBooking(id);

    if (questionnaire) {
      await openPopup(POPUP_RENDER_KEYS.SUBJECTIVE_QUESTIONNAIRE, {
        questionnaire,
        onSave: this.__handlers.save,
      });
    } else {
      await this.__checkInAppointment();
    }
  }

  async __checkInAppointment(questionnaireNarrative, noChangeInSymptoms) {
    const id = this.__appointmentId;

    await checkInAppointment({
      id,
      body: {
        selfCheckInQuestionnaireNarrative: questionnaireNarrative,
        selfCheckInQuestionnaireNoChangeInSymptoms: noChangeInSymptoms,
      },
    });

    store.dispatch(openSuccess('Appointment checked in successfully'));

    this.__futureAppointmentsFetchService.fetch();
  }

  __onMapItem(appointment) {
    const provider = this.providers.find(p => p.id === appointment.providerId);

    return { ...appointment, provider };
  }

  __getExpandFlags() {
    return this.layout === 'small'
      ? this.__futureAppointments.map(appointment =>
          canCheckInAppointment(appointment, this.selfCheckInInterval),
        )
      : [];
  }

  __renderPagination(id, pageCount, currentPage, pageChangedHandler) {
    return pageCount > 1
      ? html`
          <neb-pagination
            id="${id}-pagination"
            class="pagination"
            .pageCount="${pageCount}"
            .currentPage="${currentPage}"
            .onPageChanged="${pageChangedHandler}"
            .layout="${this.layout}"
          ></neb-pagination>
        `
      : '';
  }

  __renderErrorBanner() {
    store.dispatch(
      openError('An error occurred when checking in the appointment'),
    );
  }

  render() {
    return html`
      <div class="icon-container">
        ${
          this.enableBooking
            ? html`
                <neb-md-button
                  id="${ELEMENTS.bookAnotherButton.id}"
                  class="button"
                  label="${TEXT_BOOK_ANOTHER_BUTTON}"
                  @click="${this.__handlers.navigateToBookAppointment}"
                  outlined
                ></neb-md-button>
              `
            : ''
        }
      </div>

      <div class="title">${UPCOMING_APPOINTMENTS}</div>

      <neb-text class="sub-header">
        You can check in ${
          SELF_CHECK_IN_INTERVAL_MESSAGE[this.selfCheckInInterval]
        }
      </neb-text>

      <neb-table-appointments
        id="${ELEMENTS.upcomingAppointmentsTable.id}"
        .model="${this.__futureAppointments}"
        .config="${CONFIG}"
        .mode="${this.layout === 'small' ? MODE.DETAIL : MODE.NONE}"
        .layout="${this.layout}"
        .expandFlags="${this.__getExpandFlags()}"
        .onSelectRow="${this.__handlers.openAppointment}"
        .onCheckIn="${this.__handlers.checkInAppointment}"
        .enableSelfCheckIn="${this.enableSelfCheckIn}"
        .selfCheckInInterval="${this.selfCheckInInterval}"
      >
        <neb-text slot="noItemsText">
          You have no upcoming appointments at this time. ${
            this.enableBooking
              ? html`<br />Click
          <neb-text
            id="${ELEMENTS.createAppointment.id}"
            name="#/book-appointment"
            link
            .onClick="${this.__handlers.navigateToBookAppointment}"
            >here</neb-text
          >
          to schedule an appointment.
        </neb-text>`
              : ''
          }
      </neb-table-appointments>

      ${this.__renderPagination(
        TYPE.FUTURE,
        this.__futurePageCount,
        this.__futureCurrentPage,
        this.__handlers.futurePageChanged,
      )}

      <div class="title">${PAST_APPOINTMENTS}</div>
      <neb-table-appointments
        id="${ELEMENTS.pastAppointmentsTable.id}"
        .model="${this.__pastAppointments}"
        .config="${CONFIG}"
        .mode="${this.layout === 'small' ? MODE.DETAIL : MODE.NONE}"
        .layout="${this.layout}"
        .onSelectRow="${this.__handlers.openAppointment}"
      >
        <span slot="noItemsText"
          >You have no past appointments at this time.</span
        ></neb-table-appointments
      >

      ${this.__renderPagination(
        TYPE.PAST,
        this.__pastPageCount,
        this.__pastCurrentPage,
        this.__handlers.pastPageChanged,
      )}
    `;
  }
}

customElements.define('neb-my-appointments', NebMyAppointments);
